var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-drawer"},[_c('div',{staticClass:"custom-drawer__header"},[_c('h6',{staticClass:"semibold-16 text--left mrg-bottom-0"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }